var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fade-in-background-wrapper"},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"fade-in-background-image",attrs:{"src":_vm.bg},on:{"load":_vm.onLoaded,"error":_vm.error}}),_vm._v("  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }